<script setup lang="ts">
  import { ref, toRef } from "vue";
  import { QrCode, ChevronDown, Download } from "lucide-vue-next";
  import { useQrCode } from "@/composables/useQrCode";
  import { Button } from "@/components/ui/button";
  import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
  } from "@/components/ui/dropdown-menu";
  import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
  } from "@/components/ui/dialog";

  const props = defineProps<{
    url: string;
    label: string;
    filename: string;
  }>();

  const modalOpen = ref(false);
  const { svg, download } = useQrCode(toRef(props, "url"));
</script>

<template>
  <div class="flex">
    <Button
      variant="outline"
      class="rounded-r-none border-r-0"
      :disabled="!svg"
      @click="modalOpen = true">
      <QrCode class="h-4 w-4" />
      QR code
    </Button>
    <DropdownMenu>
      <DropdownMenuTrigger as-child>
        <Button
          variant="outline"
          size="icon"
          class="rounded-l-none px-2"
          :disabled="!svg">
          <ChevronDown class="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem @select="download(filename)">
          <Download class="h-4 w-4" />
          Download QR code
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  </div>

  <Dialog v-model:open="modalOpen">
    <DialogContent class="font-sans sm:max-w-md">
      <DialogHeader>
        <DialogTitle>QR code — {{ label }} link</DialogTitle>
        <DialogDescription class="break-all">{{ url }}</DialogDescription>
      </DialogHeader>
      <div class="flex justify-center p-4">
        <!-- eslint-disable-next-line vue/no-v-html -->
        <div
          class="h-64 w-64 rounded-2xl border border-border bg-white p-4 shadow-sm [&>svg]:h-full [&>svg]:w-full"
          v-html="svg" />
      </div>
      <DialogFooter>
        <Button
          variant="outline"
          :disabled="!svg"
          @click="download(filename)">
          <Download class="h-4 w-4" />
          Download QR code
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
</template>
